import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Heart, HeartOff, Star } from "lucide-react";

const FoodCard = ({
  id,
  images = [],
  name,
  description,
  price,
  rating = 4.5,
}) => {
  const { addToCart } = useCart();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [wishlisted, setWishlisted] = useState(false);

  const handleOrderNow = (e) => {
    e.stopPropagation();
    if (!currentUser) {
      navigate("/signup");
      return;
    }
    addToCart({ id, name, description, price, image: images[0], quantity: 1 });
  };

  const toggleWishlist = (e) => {
    e.stopPropagation();
    setWishlisted((prev) => !prev);
  };

  const goToDetail = () => {
    navigate(`/product/${id}`);
  };

  const originalPrice = (price * 1.3).toFixed(2); // 30% higher for strike-through

  return (
    <div
      onClick={goToDetail}
      className="bg-white p-1 rounded-lg shadow hover:shadow-lg transition flex flex-col relative cursor-pointer"
    >
      {/* 30% OFF Badge */}
      <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 text-xs font-semibold rounded">
        30% OFF
      </div>

      {/* Image */}
      <div className="w-full h-40 md:h-48 bg-[#e5e5e5] flex items-center justify-center">
        {images[0] ? (
          <img
            src={images[0]}
            alt={name}
            className="w-full h-full object-cover rounded"
          />
        ) : (
          <div className="w-24 h-24 bg-gray-400 animate-pulse rounded"></div>
        )}
      </div>

      {/* Content */}
      <div className="p-3 flex flex-col flex-grow">
        <h3 className="font-semibold text-gray-800 text-sm md:text-base line-clamp-2">
          {name}
        </h3>

        <p className="text-gray-600 text-xs md:text-sm line-clamp-2 mt-1">
          {description}
        </p>

        {/* Price */}
        <div className="flex items-center gap-2 mt-2">
          <p className="text-indigo-600 font-bold text-sm md:text-base">
            Rs. {price.toFixed(2)}
          </p>
          <p className="text-gray-400 line-through text-xs md:text-sm">
            Rs. {originalPrice}
          </p>
        </div>

        {/* Order Now Button */}
        {/* <button
          onClick={handleOrderNow}
          className="mt-3 w-full bg-yellow-500 hover:bg-yellow-600 text-white py-2 rounded text-xs md:text-sm font-semibold transition"
        >
          Order Now
        </button> */}
      </div>

      {/* Wishlist Heart */}
      <button
        onClick={toggleWishlist}
        className="absolute top-2 right-2 p-1 rounded-full bg-white shadow hover:bg-red-50 transition"
      >
        {wishlisted ? (
          <Heart className="w-5 h-5 text-red-500 fill-red-500" />
        ) : (
          <HeartOff className="w-5 h-5 text-gray-400" />
        )}
      </button>

      {/* Rating */}
      {/* <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-white px-2 py-1 rounded shadow text-xs">
        <Star className="w-3 h-3 text-yellow-400" />
        <span className="text-black">{rating}</span>
      </div> */}
    </div>
  );
};

export default FoodCard;
